module.exports = __webpack_public_path__ + "static/img/story6.2c75e63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/story6.jpg
// module id = GVxf
// module chunks = 0